import styles from "./userAvatar.module.scss";

interface UserAvatarProps {
  photo?: string | null;
  name?: string | null;
  size?: "small" | "medium" | "large";
  className?: string;
}

function getInitials(name: string | null | undefined): string {
  if (!name || !name.trim()) return "?";
  const first = name.trim().charAt(0).toUpperCase();
  return first;
}

export function UserAvatar({ photo, name, size = "medium", className }: UserAvatarProps) {
  const initials = getInitials(name);
  const sizeClass = styles[size];

  if (photo) {
    return (
      <img
        src={photo}
        alt=""
        className={`${styles.avatar} ${sizeClass}${className ? ` ${className}` : ""}`}
      />
    );
  }

  return (
    <div
      className={`${styles.avatar} ${styles.initials} ${sizeClass}${className ? ` ${className}` : ""}`}
      aria-hidden
    >
      {initials}
    </div>
  );
}
